var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 158"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1246",
    cx: 11,
    cy: 11,
    r: 10.5,
    fill: "#F5F4FE",
    stroke: "#735BF2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7904 7.20675C17.0699 7.48241 17.0699 7.92935 16.7904 8.20502L10.1124 14.7933C9.83298 15.0689 9.37994 15.0689 9.10052 14.7933L6.20957 11.9412C5.93015 11.6655 5.93015 11.2186 6.20957 10.9429C6.48899 10.6672 6.94202 10.6672 7.22145 10.9429L9.60646 13.2958L15.7786 7.20675C16.058 6.93108 16.511 6.93108 16.7904 7.20675Z",
    fill: "#735BF2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelect);
export default __webpack_public_path__ + "static/media/iconSelect.3775e70825dda6a3e7bb32aed5cbb48d.svg";
export { ForwardRef as ReactComponent };